import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { GlxyInputTagsComponent } from '@vendasta/forms';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, of } from 'rxjs';
import { catchError, finalize, take, tap } from 'rxjs/operators';
import { SalesOrderTagsService, UIOptions } from './sales-order-details-tags.service';

@Component({
  selector: 'sales-ui-sales-order-details-tags',
  templateUrl: 'sales-order-details-tags.component.html',
  styleUrls: ['sales-order-details-tags.component.scss', '../sales-order-details-card.component.scss'],
  providers: [SalesOrderTagsService],
  standalone: false,
})
export class SalesOrderDetailsTagsComponent implements OnInit {
  maxTags = 15;
  private vaInputTags: GlxyInputTagsComponent;

  @ViewChild(GlxyInputTagsComponent) set content(content: GlxyInputTagsComponent) {
    if (content) {
      this.vaInputTags = content;
    }
  }

  @Input() tags?: string[];
  @Input() orderId: string;
  @Input() businessId: string;
  @Input() partnerId: string;
  @Input() marketId: string;
  @Input() editable = true;

  isEditing: boolean;
  editingTags: string[];
  isSubmittingTags = false;
  options$: Observable<UIOptions>;

  constructor(
    private orderTagsService: SalesOrderTagsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly snackbarService: SnackbarService,
  ) {}

  ngOnInit(): void {
    this.orderTagsService.initialize(this.businessId, this.orderId, this.partnerId, this.marketId);
    this.options$ = this.orderTagsService.tagOptions$;
  }

  public editTags(): void {
    this.editingTags = this.tags;
    this.isEditing = true;
  }

  public sendTags(): void {
    if (this.vaInputTags.overMaxFields) {
      this.snackbarService.openErrorSnack('FRONTEND.SALES_UI.MAX_TAGS', {
        interpolateTranslateParams: { maxTags: this.maxTags.toString() },
      });
      return;
    }
    const newTags = this.vaInputTags.value;

    if (this.tags === newTags) {
      this.isEditing = false;
      return;
    }

    this.isSubmittingTags = true;

    this.orderTagsService
      .updateTags(newTags)
      .pipe(
        take(1),
        tap((t) => {
          this.isEditing = false;
          this.tags = t.tags || [];
        }),
        catchError(() => {
          this.editingTags = newTags;
          this.snackbarService.openErrorSnack('FRONTEND.SALES_UI.TAGS_ERROR');
          return of(null);
        }),
        finalize(() => {
          this.isSubmittingTags = false;
          this.cdr.detectChanges(); // update state of isEditing and isSubmittingTags
        }),
      )
      .subscribe();
  }
}
